"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mui_1 = require("tss-react/mui");
const react_redux_1 = require("react-redux");
const categories_1 = require("companion-app-components/flux/categories");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const transactions_1 = require("companion-app-components/flux/transactions");
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const QTypography_1 = __importDefault(require("components/MUIWrappers/QTypography"));
const CategoryField_1 = __importDefault(require("components/QuickenControls/CategoryField"));
const utils_1 = require("utils/utils");
const CategoryMenuHeader_1 = __importDefault(require("./CategoryMenuHeader"));
const styles_1 = require("./styles");
const isIe = require('is-iexplorer') || (0, utils_1.isOldEdge)(); // eslint-disable-line
const categoryFieldInputProps = {
    style: {
        height: isIe ? 27 : 24,
    },
};
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const RegCategoryField = ({ txn, wrapText, editable, forceStatic, longCats, showSplitWindow, inputRef, onChange, context, defaultPropogateStatus = false, }) => {
    var _a, _b, _c;
    const { classes, theme } = useStyles();
    const [propagateStatus, setPropagateStatus] = (0, react_1.useState)(defaultPropogateStatus);
    const showCategorySettings = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state).get('showCategorySettings'), react_redux_1.shallowEqual);
    const isEntitySharedUser = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.isEntityShareUser);
    const handleHeaderCheckboxClick = () => setPropagateStatus(!propagateStatus);
    const categoryFieldHeader = (<CategoryMenuHeader_1.default checked={propagateStatus} boxClick={handleHeaderCheckboxClick} payee={txn.payee}/>);
    const categoryFieldMenuClose = (0, react_1.useCallback)(() => setPropagateStatus(false), []);
    const categoryFieldOnChange = (0, react_1.useCallback)((coa) => {
        const e = { target: { value: coa, doPropogate: propagateStatus } };
        onChange(e, 'category');
    }, [propagateStatus, onChange]);
    if (!transactions_1.transactionsUtils.isSplitTxn(txn)) {
        return (<CategoryField_1.default 
        // @ts-expect-error: Property 'header' does not exist on type 'IntrinsicAttributes & CategoryFieldProps'.
        header={((_a = txn.payee) === null || _a === void 0 ? void 0 : _a.length) > 0 ? categoryFieldHeader : undefined} menuClose={categoryFieldMenuClose} onChange={categoryFieldOnChange} 
        // @ts-expect-error: Property 'register' does not exist on type 'Components<BaseTheme>'.
        disableUnderline={(_b = theme.components) === null || _b === void 0 ? void 0 : _b.register.noUnderline} name={editable ? 'regCatEditable' : 'static'} returnSelectionMethod editable={editable} createEnabled={!isEntitySharedUser && showCategorySettings} recommendedCategoryType={txn.amount > 0 ? categories_1.categoriesTypes.CategoryTypeEnum.INCOME : categories_1.categoriesTypes.CategoryTypeEnum.EXPENSE} clickable={!forceStatic && !showSplitWindow} value={txn.coa} 
        // @ts-expect-error: Property 'register' does not exist on type 'Components<BaseTheme>'.
        fontSize={(_c = theme.components) === null || _c === void 0 ? void 0 : _c.register.fontSize.default} classNameWhenNotEditable={classes.regItemCore} autoFocus tooltip={!wrapText} longCats={longCats} inputRef={inputRef} InputProps={categoryFieldInputProps} context={context} txn={txn}/>);
    }
    return (<QTypography_1.default clickable thinFont className={classes.regItemCore}>
      --- Split ---
    </QTypography_1.default>);
};
exports.default = RegCategoryField;
